import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import Pagination from '../../pagination/pagination.component';
import CardBiography from './card-biography.component';
import NoData from '../../no-data/no-data.component';

// styles , icons and images
import { Row, Col } from 'react-bootstrap';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Paper } from '@material-ui/core';


// this component represents the videos container part in visumes/biographies page 

export default class YourBiographiesPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: this.props.data
        }
    }
    render() {
        console.log(this.props)
        if (!this.props.data) {
            return (<div>Loading...</div>)
        }
        else {
            return (
                <div style={{ borderTop: '3px solid #e85a19' }}>
                    <div className="container-responsive">
                        <Paper elevation={3}>
                            <Row elevation={3} className="bg-light m-0 p-3" style={{ borderBottom: '1px solid #f2f2f2' }}>
                                <Col sm={6} xs={12}>
                                    <h5 className="mb-0">{this.props.type}</h5>
                                </Col>
                                <Col className="text-right" sm={6} xs={12}>
                                    <h6 className="bold mb-0"
                                    >Sort by: <Link className="text-orange" to=''
                                        onClick={e => {
                                            e.preventDefault();
                                            if(this.props.data.data?.length > 0){
                                                this.setState({ ...this.state, filterdArray: this.props.data.reverse() });
                                            }
                                        }
                                        }>Latest</Link> <ExpandMoreIcon /></h6>
                                </Col>
                            </Row>
                            <Pagination card={this.props.data && this.props.data}>
                                <CardBiography />
                            </Pagination>
                        </Paper>
                    </div>
                </div>
                );
        }
    }
}